import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';

import SwbMerchantLogisComListForSelect from './MerchantLogisComListForSelect';
Vue.regist(SwbMerchantLogisComListForSelect);

import SwbMerchtLogisComSet from './MerchtLogisComSet';
Vue.regist(SwbMerchtLogisComSet);

export function openLogisComSelectDlg(checkBox, selectIds, parmas, callback) {
    checkBox = Utils.isTrue(checkBox);
    let theDlg = Vue.$showDialog({
        title: '物流公司 - 选择',
        width: 800,
        height: 700,
        template: '<div>' +
        '<swb-merchant-logis-com-list-for-select :checkBox="checkBox" :selectIds="selectIds" :filter="filter" ref="swb_logis_com_list_for_select"></swb-merchant-logis-com-list-for-select>' +
        '</div>',
        data: {
            checkBox: checkBox,
            selectIds: selectIds,
            filter: parmas
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_logis_com_list_for_select.getDlgResult() || {};
            if(result != null && result.type == 'info') {
                let logisComInfo = result.data || {};
                callback(logisComInfo, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return true;
        },
        lifecycle: {}
    })
}

// 设置物流信息
export function openLogisComSetDlg(parmas, callback) {
    let title = parmas["title"] || "物流信息 - 设置";
    //
    let requiredFlag = Utils.isTrue(parmas["requiredFlag"]);
    let merchantId = parmas["merchantId"] || null;
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: 600,
        height: 500,
        showCloseBtn: true,
        template: '<div class = "">' +
        '<swb-logis-com-set :requiredFlag="requiredFlag" :merchantId="merchantId" ref="swb_logis_com_set"></swb-logis-com-set>' +
        '</div>',
        data: {
            requiredFlag: requiredFlag,
            merchantId: merchantId
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_logis_com_set.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    let logisCom = result.data;
                    //
                    callback(logisCom, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/merchtLogis/showDlg.js
// module id = 323
// module chunks = 0